module.exports = __webpack_public_path__ + "media/toolkits/icon-play-circle-84b0b765.png";